import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'

import type { PageRead } from '@components/table/types'
import type { BankNotification } from '@features/banking/types'

export const bankNotificationsQueryKey = ['bank-notifications']

/** Fronta bankových notifikácií — stránkovanie a filtre číta z URL, rovnako
 * ako ostatné admin tabuľky. */
export function useBankNotificationsTable() {
  const [searchParams] = useSearchParams()
  const limit = searchParams.get('limit')
  const offset = searchParams.get('offset')
  const q = searchParams.get('q')
  // Predvolene sa ukazuje to, čo treba riešiť; „všetky" je vedomá voľba.
  const status = searchParams.get('status') ?? 'UNMATCHED'

  async function getNotifications(): Promise<PageRead<BankNotification>> {
    const res = await apiClient.get<PageRead<BankNotification>>(
      `${BACK_OFFICE_PREFIX}bank-notifications`,
      { params: { limit, offset, search: q, status: status || undefined } }
    )
    return res.data
  }

  return useQuery({
    queryFn: getNotifications,
    queryKey: [...bankNotificationsQueryKey, limit, offset, q, status]
  })
}
